module.exports = __webpack_public_path__ + "media/src/images/icons/tag-5ea3833d09aad557e0ca96331810272f.svg";